module.exports = __webpack_public_path__ + "img/Brownfield project.1dbe4704.png";